import MuiMenu, { type MenuProps } from '@mui/material/Menu';
import MuiListItemIcon, { type ListItemIconProps } from '@mui/material/ListItemIcon';
import MuiListItemText, { type ListItemTextProps } from '@mui/material/ListItemText';

export type { MenuProps, ListItemIconProps, ListItemTextProps };

export const ListItemIcon = (props: ListItemIconProps) => <MuiListItemIcon {...props} />;
export const ListItemText = (props: ListItemTextProps) => <MuiListItemText {...props} />;

const Menu = (props: MenuProps) => <MuiMenu {...props} />;

export default Menu;
